export default "__VITE_ASSET__e7dcd4bc__"